import { render, staticRenderFns } from "./ViewMyTraining.vue?vue&type=template&id=eb6af2c8&scoped=true"
import script from "./ViewMyTraining.vue?vue&type=script&lang=js"
export * from "./ViewMyTraining.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb6af2c8",
  null
  
)

export default component.exports